import { memo } from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  value: boolean;
};
type StyleMap = Record<string, { backgroundColor: string; color: string }>;

const STYLES: StyleMap = {
  true: { backgroundColor: 'success.light', color: 'success.dark' },
  false: { backgroundColor: 'warning.light', color: 'warning.main' },
};

const ClientStatusChip = ({ value }: Props) => {
  const { t } = useTranslation('client');
  const statusKey = String(value);
  return (
    <Chip
      label={t(`statusName.${value ? 'ACTIVE' : 'INACTIVE'}`)}
      sx={{ pX: 2, pY: 2, minWidth: '88px', textTransform: 'uppercase', ...STYLES[statusKey] }}
    />
  );
};

export default memo(ClientStatusChip);
